import { useContext } from 'react';

import MapContext from './MapContext';
const useMapContext = () => {
  return useContext(MapContext);
};

export default useMapContext;
